import { Effect, Layer, Result, Scope } from "effect";
import { chunkRecoveryIoFailure, chunkReloadGuardKey } from "./model.ts";
import { ChunkRecoveryIo } from "./service.ts";

const native = <A>(body: () => A) => Effect.try({ try: body, catch: chunkRecoveryIoFailure });
export const ChunkRecoveryIoLive = Layer.succeed(ChunkRecoveryIo, ChunkRecoveryIo.of({
  now: native(() => Date.now()),
  readGuard: native(() => window.sessionStorage.getItem(chunkReloadGuardKey)),
  writeGuard: now => native(() => { window.sessionStorage.setItem(chunkReloadGuardKey, String(now)); }),
  reload: native(() => { window.location.reload(); }),
  listen: notify => Effect.gen(function* () {
    const owner = yield* Scope.Scope;
    if (owner.state._tag === "Closed" || typeof window === "undefined") return;
    yield* Effect.acquireRelease(native(() => {
      const listener = (event: Event) => {
        // Vite must see cancellation before dispatchEvent returns. Its payload
        // is an unknown cause and is never read or coerced.
        const result = Result.try(() => {
          Event.prototype.preventDefault.call(event);
          notify({ _tag: "PreloadError" });
        });
        if (Result.isFailure(result)) notify({ _tag: "ListenerFailure", error: chunkRecoveryIoFailure(result.failure) });
      };
      window.addEventListener("vite:preloadError", listener);
      return listener;
    }), listener => native(() => { window.removeEventListener("vite:preloadError", listener); }).pipe(Effect.orDie));
  })
}));
